import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const faqs = [{
  question: '¿Necesito experiencia en servicios financieros?',
  answer: 'No. Recibirás capacitación y acompañamiento durante el proceso.'
}, {
  question: '¿Tengo que dejar mi trabajo actual?',
  answer: 'No. La oportunidad puede desarrollarse de manera flexible.'
}, {
  question: '¿Necesito obtener una licencia?',
  answer: 'Algunas actividades requieren capacitación y las licencias correspondientes. El proceso se explica durante la conversación.'
}, {
  question: '¿La conversación me compromete a comenzar?',
  answer: 'No. El objetivo es conocer cómo funciona, hacer tus preguntas y decidir si es para ti.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduced = useReducedMotion();
  return <section id="preguntas" className="w-full scroll-mt-16 bg-ivory py-24 sm:py-32 lg:py-40" aria-labelledby="faq-title" data-id="element-56" data-mp="phek65iujhgx">
      <div className="mx-auto grid max-w-page grid-cols-1 gap-12 px-5 sm:px-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-24 lg:px-12" data-id="element-57" data-mp="ug9bxwyskgd6">
        <Reveal data-id="element-58" data-mp="fm4jbl46pg4q">
          <h2 id="faq-title" className="font-sans text-[1.85rem] font-light uppercase leading-[1.12] text-ink sm:text-[2.5rem]" data-id="element-59" data-mp="kil72e7h1sha">
            Antes de decidir,
            <br data-id="element-60" data-mp="bhwqpculvg18" />
            es normal tener
            <br data-id="element-61" data-mp="bjpxcs57y098" />
            preguntas.
          </h2>
        </Reveal>

        <div className="border-t border-ink/15" data-id="element-62" data-mp="3szfy8wewpofj">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} className="border-b border-ink/12" data-id="element-63" data-mp="1q94prgtir75" data-mpi={i}>
                <h3 data-id="element-64" data-mp="3jz9q7q1z9gnr">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-6 py-7 text-left transition-colors duration-200 ease-out hover:text-steel" data-id="element-65" data-mp="3k02y4ucoac7h">
                    <span className="font-sans text-[17px] font-light leading-snug text-ink sm:text-lg" data-id="element-66" data-mp="1kqrt9v1f6vrp">
                      {faq.question}
                    </span>
                    {isOpen ? <MinusIcon className="mt-1 h-4 w-4 flex-none text-champagne" strokeWidth={1.5} aria-hidden="true" data-id="element-67" data-mp="2dg8larl4oane" /> : <PlusIcon className="mt-1 h-4 w-4 flex-none text-champagne" strokeWidth={1.5} aria-hidden="true" data-id="element-68" data-mp="23fy6x3ncwx6n" />}
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-69" data-mp="nzzdyzmb97qz">
                  {isOpen && <motion.div initial={reduced ? undefined : {
                height: 0,
                opacity: 0
              }} animate={reduced ? undefined : {
                height: 'auto',
                opacity: 1
              }} exit={reduced ? undefined : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-70" data-mp="2zox7sy08sg9o">
                      <p className="max-w-xl pb-8 pr-10 font-sans text-base font-light leading-relaxed text-steel sm:text-[17px]" data-id="element-71" data-mp="3ndgfbbbgwp0p">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}